import React from 'react'
import { observer } from 'mobx-react'
import { Droppable } from 'react-beautiful-dnd'

import VerbatimChartSlot from './components/VerbatimChartSlot'

const Verbatim = observer(({ store }) => (
    <div style={{ display: 'flex', height: '100%', marginTop: 40 }}>
        <Droppable key={0} droppableId={`slide-${0}`}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{ width: '100%', height: 'calc(100% - 60px)', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}
                >
                    <VerbatimChartSlot
                        store={store}
                        key={0}
                        slide={store.activeSlide}
                        position={0}
                    />
                </div>
            )}
        </Droppable>
    </div>
))

export default Verbatim
